import { Link } from "react-router-dom";
import { Trash2 } from "lucide-react";
import { Button, Card, CardContent } from "@/components/primitives";
import { formatRelativeDate } from "@/lib/utils";
import type { Reflection } from "../types";

interface DraftReflectionCardProps {
	draft: Reflection;
	onDelete: (draftId: string, event: React.MouseEvent) => void;
}

export function DraftReflectionCard({
	draft,
	onDelete,
}: DraftReflectionCardProps) {
	return (
		<Card className="border-2 shadow-xl bg-white/90 dark:bg-slate-800/90 backdrop-blur-sm hover:shadow-2xl transition-all duration-200 border-border/50 hover:border-primary/50 relative">
			<Button
				variant="ghost"
				size="sm"
				className="absolute top-2 right-2 h-8 w-8 p-0 z-10"
				onClick={(e) => onDelete(draft.id, e)}
			>
				<Trash2 className="h-4 w-4" />
			</Button>

			<Link to={`/reflection/continue/${draft.id}`}>
				<CardContent className="p-4 sm:p-6 pr-12">
					<div className="space-y-3">
						<div className="flex items-start gap-3">
							<h3 className="font-semibold text-foreground break-words flex-1 min-w-0">
								{draft.title || "Untitled Reflection"}
							</h3>
							<span className="inline-flex items-center px-2 py-1 rounded-full text-xs bg-muted text-muted-foreground shrink-0">
								Draft
							</span>
						</div>

						<p className="text-sm text-muted-foreground line-clamp-2 leading-relaxed">
							{draft.description || "Continue working on this reflection..."}
						</p>

						<div className="flex items-center justify-between gap-3">
							<span className="text-xs text-muted-foreground flex-1 min-w-0">
								{formatRelativeDate(draft.created_at)}
							</span>
							<Button size="sm" variant="outline" className="text-xs shrink-0">
								Continue
							</Button>
						</div>
					</div>
				</CardContent>
			</Link>
		</Card>
	);
}
